import React from "react";


export default ({errorMessages}) =>
    <ul className={"space-y-4 text-red-500 list-disc list-inside dark:text-red-400"}>
        { errorMessages.map((message, idx) =>
            <li
                key={`m-${idx}`}
                className="mt-2 text-sm text-red-600 dark:text-red-500">
                {message}
            </li>
        )}
    </ul>